<template>
	<v-dialog slot="activator" v-model="dialog" persistent max-width="450px">
		<v-btn slot="activator" icon >
			<v-icon color="grey darken-2">{{this.icon}}</v-icon>
		</v-btn>
		<v-card>
			<v-toolbar>
				<v-toolbar-title>
					DELETE ALL ROOMS AND FLOORS
				</v-toolbar-title>
			</v-toolbar>
			<v-card-title class="body-2" color="black">
				<v-layout column class="pl-1 pt-2"> 
				</v-layout>
			</v-card-title>
			<v-card-text class="pb-5" v-if="dvBuildingRooms && dvBuildingRooms.length > 0">
				Delete all {{dvBuildingRooms.length}} Rooms, Floors and their related child records?
			</v-card-text>
			<v-card-text class="pb-5" v-else>
				No rooms in this building
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="green darken-1" flat @click.native="dialog=false">
					Cancel
				</v-btn>
				<!-- v-if="dvBuildingRooms && useDevDatabase" -->
				<v-btn v-if="dvBuildingRooms" color="green darken-1" flat @click.native="execute">
					Delete
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

export default {
	data() {
		return {
			dialog: false,
		}
	},

	props: [ 'icon' ],

	computed: {
		...mapState({		dvSelectedBuilding: state => state.dv.building,
							dvBuildingRooms: state => state.dv.buildingRooms,
							useDevDatabase: state => state.ui.useDevDatabase,
		}),
	},

	methods: {
		...mapMutations([	'setSnackText', 'setdvBuildingRooms'		]),
		...mapActions([		'deleteAllRooms', 'refreshBuilding'			]),

		execute: function() {

			// Delete all rooms for selected building
			this.deleteAllRooms({ bldgAlpha: this.dvSelectedBuilding.bldgAlpha }).then((response) => {
				 this.setSnackText(response) 
				 //this.setdvBuildingRooms(null)
				 this.refreshBuilding(this.dvSelectedBuilding.bldgAlpha)
			})

			this.dialog=false
		}
	}
}

</script>

<style></style>



// WEBPACK FOOTER //
// src/components/forms/BldgViewer/DeleteAllRoomsDialog.vue